<template>
  <div>
    <b-modal v-model="showResumenModal" title="Resumen de Avances" size="xl" hide-footer>
      <div>
        <div class="mb-3">
          <h4 class="mb-1 font-weight-bold text-primary">Resumen de Avances del Usuario</h4>
          <p class="text-muted mb-0">
            <i class="bi bi-info-circle mr-1"></i>
            Visualiza todos los avances y actividades realizadas por el usuario
          </p>
        </div>
        
        <b-tabs content-class="mt-3" v-if="resumenAvances">
          <!-- Actividades -->
          <b-tab title="Actividades" :active="resumenAvances.actividades && resumenAvances.actividades.length > 0">
            <div v-if="resumenAvances.actividades && resumenAvances.actividades.length > 0">
              <b-table striped hover small :items="resumenAvances.actividades" 
                :fields="[{key:'nombre',label:'Actividad'},{key:'curso',label:'Curso'},{key:'curricula',label:'Currícula'},{key:'calificacion',label:'Calificación'},{key:'fecha',label:'Fecha'}]"
                responsive>
                <template #cell(calificacion)="{ value }">
                  <b-badge :variant="value >= 80 ? 'success' : value >= 60 ? 'warning' : 'danger'">{{ value }}</b-badge>
                </template>
              </b-table>
            </div>
            <div v-else class="text-muted text-center py-4">No hay actividades registradas</div>
          </b-tab>

          <!-- Avances de Cursos -->
          <b-tab title="Avances de Cursos">
            <div v-if="resumenAvances.avances_cursos && resumenAvances.avances_cursos.length > 0">
              <b-table striped hover small :items="resumenAvances.avances_cursos" 
                :fields="[{key:'curso',label:'Curso'},{key:'curricula',label:'Currícula'},{key:'avance',label:'Avance'},{key:'fecha',label:'Fecha'}]"
                responsive>
                <template #cell(avance)="{ value }">
                  <b-progress :value="parseFloat(value)" :max="100" show-progress animated></b-progress>
                </template>
              </b-table>
            </div>
            <div v-else class="text-muted text-center py-4">No hay avances de cursos registrados</div>
          </b-tab>

          <!-- Entregables -->
          <b-tab title="Entregables">
            <div v-if="resumenAvances.entregables && resumenAvances.entregables.length > 0">
              <b-table striped hover small :items="resumenAvances.entregables" 
                :fields="[{key:'actividad',label:'Actividad'},{key:'curso',label:'Curso'},{key:'curricula',label:'Currícula'},{key:'calificacion',label:'Calificación'},{key:'url',label:'URL'},{key:'fecha',label:'Fecha'}]"
                responsive>
                <template #cell(calificacion)="{ value }">
                  <b-badge :variant="value >= 80 ? 'success' : value >= 60 ? 'warning' : 'danger'">{{ value }}</b-badge>
                </template>
                <template #cell(url)="{ value }">
                  <a v-if="value" :href="value" target="_blank" class="btn btn-sm btn-outline-info">
                    <b-icon icon="link"></b-icon>
                  </a>
                  <span v-else class="text-muted">-</span>
                </template>
              </b-table>
            </div>
            <div v-else class="text-muted text-center py-4">No hay entregables registrados</div>
          </b-tab>

          <!-- Exámenes -->
          <b-tab title="Exámenes">
            <div v-if="resumenAvances.examenes && resumenAvances.examenes.length > 0">
              <b-table striped hover small :items="resumenAvances.examenes" 
                :fields="[{key:'nombre',label:'Examen'},{key:'curso',label:'Curso'},{key:'calificacion',label:'Calificación'},{key:'fecha',label:'Fecha'}]"
                responsive>
                <template #cell(calificacion)="{ value }">
                  <b-badge :variant="value >= 80 ? 'success' : value >= 60 ? 'warning' : 'danger'">{{ value }}</b-badge>
                </template>
              </b-table>
            </div>
            <div v-else class="text-muted text-center py-4">No hay exámenes registrados</div>
          </b-tab>

          <!-- Videos -->
          <b-tab title="Videos">
            <div v-if="resumenAvances.videos && resumenAvances.videos.length > 0">
              <b-table striped hover small :items="resumenAvances.videos" 
                :fields="[{key:'objetivo',label:'Objetivo'},{key:'curso',label:'Curso'},{key:'curricula',label:'Currícula'},{key:'accion',label:'Acción'},{key:'tiempo',label:'Tiempo (seg)'},{key:'fecha',label:'Fecha'}]"
                responsive>
                <template #cell(accion)="{ value }">
                  <b-badge :variant="value === 'complete' ? 'success' : value === 'pause' ? 'warning' : 'info'">{{ value }}</b-badge>
                </template>
              </b-table>
            </div>
            <div v-else class="text-muted text-center py-4">No hay videos registrados</div>
          </b-tab>

          <!-- Cursos Terminados -->
          <b-tab title="Cursos Terminados">
            <div v-if="resumenAvances.cursos_terminados && resumenAvances.cursos_terminados.length > 0">
              <b-table striped hover small :items="resumenAvances.cursos_terminados" 
                :fields="[{key:'curso',label:'Curso'},{key:'curricula',label:'Currícula'},{key:'modo_termino',label:'Modo de Término'},{key:'fecha',label:'Fecha'}]"
                responsive>
                <template #cell(modo_termino)="{ value }">
                  <b-badge :variant="value === 'Revalidado' ? 'info' : 'success'">{{ value }}</b-badge>
                </template>
              </b-table>
            </div>
            <div v-else class="text-muted text-center py-4">No hay cursos terminados</div>
          </b-tab>
        </b-tabs>
        
        <div v-if="!resumenAvances" class="text-center py-4">
          <b-spinner></b-spinner>
          <p class="mt-2 text-muted">Cargando resumen...</p>
        </div>
      </div>
    </b-modal>
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="card card-block">
            <div class="card-body p-2">
              <div class="d-flex justify-content-between align-items-start p-2">
                <b-jumbotron lead="Lista usuarios"></b-jumbotron>
              </div>
              <div class="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
                <div class="d-flex gap-2 align-items-center">
                  <b-form-input v-model="search" placeholder="Buscar usuario..." @keyup.enter="buscarUsuarios"
                    @change="buscarUsuarios" class="mr-2" style="max-width:200px;" />
                  <b-form-select v-model.number="selectedRol" :options="rolesFilterOptions" @change="filtrarUsuarios"
                    class="mr-2" style="max-width:150px;" />
                  <b-form-select v-model="selectedEstatus" :options="estatusFilterOptions" @change="filtrarUsuarios"
                    style="max-width:120px;" />
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <b-badge variant="primary" class="m-2">Total usuarios: {{ total }}</b-badge>
                  <b-badge variant="warning" class="mr-2" v-if="licenciasInfo.licencias_activas !== null">
                    Licencias activas: {{ licenciasInfo.licencias_activas }}
                  </b-badge>
                  <b-badge variant="success" v-if="licenciasInfo.licencias_disponibles !== null">
                    Licencias disponibles: {{ licenciasInfo.licencias_disponibles }}
                  </b-badge>
                </div>
              </div>
              <div class="d-flex justify-content-end mb-2">
                <b-button @click="nuevoUser" class="ml-5 btn-studioAPP" variant="outline-warning">
                  Nuevo
                </b-button>
                <b-button @click="abrirModalImportar" class="ml-2 btn-studioAPP" variant="outline-primary">
                  Importar
                </b-button>
                <b-button v-if="isAdmin" @click="abrirModalHistorial" class="ml-2 btn-studioAPP" variant="outline-info">
                  Historial
                </b-button>
                <b-button @click="exportarUsuarios" class="ml-2 btn-studioAPP" variant="outline-success">
                  Exportar
                </b-button>
              </div>
              <b-table class="data-table" striped hover outlined small :items="users" :fields="fields" responsive>
                <template #cell(actions)="row">
                  <div class="d-flex justify-content-around align-items-center">
                    <b-button variant="success" size="sm" @click="editUser(row.item)" v-b-tooltip.hover
                      title="Editar usuario">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-pencil-square" viewBox="0 0 16 16">
                        <path
                          d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                      </svg>
                    </b-button>
                    <b-button variant="danger" size="sm" @click="showModalEliminar(row.item)" class="ml-1"
                      v-b-tooltip.hover title="Eliminar usuario"
                      :disabled="!row.item.puede_eliminar">
                      <!-- Modal eliminar usuario -->
                      <b-modal v-model="ModalEliminar" persistent title="Confirmación" size="lg" centered>
                        <b-container fluid>
                          <b-row class="m-1 text-left">
                            <b-col cols="12">
                              ¿Estás seguro de eliminar al usuario <b>"{{ userEliminar.name }}"</b> con el correo <b>{{
                                userEliminar.email }}</b> de la base de datos? Esta acción NO SE PUEDE REVERTIR
                            </b-col>
                          </b-row>
                        </b-container>
                        <template #modal-footer>
                          <div class="w-100">
                            <b-button variant="primary" size="sm" class="float-right"
                              @click="hideModalEliminar">Cancelar</b-button>
                            <b-button variant="danger" size="sm" class="float-right mx-2"
                              @click="deleteUser">Eliminar</b-button>
                          </div>
                        </template>
                      </b-modal>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash-fill" viewBox="0 0 16 16">
                        <path
                          d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                      </svg>
                    </b-button>
                    <b-button variant="info" size="sm" @click="abrirModalCurriculas(row.item)" class="ml-1"
                      v-b-tooltip.hover title="Ver Resumen de Avances">
                      <b-icon icon="eye"></b-icon>
                    </b-button>
                  </div>
                </template>
                <template #cell(estatus)="{ value }">
                  <span v-if="value == 1" class="text-success">
                    <b-icon icon="check-circle-fill" variant="success"></b-icon>
                  </span>
                  <span v-else class="text-danger">
                    <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                  </span>
                </template>
              </b-table>
              <div class="d-flex justify-content-between row p-2">
                <div class="col-sm-12 col-md-6 d-flex align-items-center"></div>
                <div class="col-sm-12 col-md-6 d-flex align-items-center justify-content-end">
                  <div>
                    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" align="fill" size="sm"
                      class="my-0" @input="cargarUsuarios" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Modal Importar Usuarios -->
      <modal-importar-usuarios 
        v-model="showImportarModal"
        :gruposOptions="gruposAprende_items"
        @importacion-exitosa="onImportacionExitosa"
      />

      <!-- Modal Editar/Crear Usuario -->
      <modal-editar-usuario
        v-model="showEditarModal"
        :usuario="usuarioSeleccionado"
        :rolesOptions="item_roles"
        :escuelasOptions="item_escuelas"
        :gruposOptions="gruposAprende_items"
        @usuario-guardado="onUsuarioGuardado"
        @usuario-actualizado="onUsuarioGuardado"
        @cerrado="onModalCerrado"
      />

      <!-- Modal Historial de Importaciones -->
      <historial-importaciones v-model="showHistorialModal" />

    </b-container>
  </div>
</template>

<script>
import GestionUsuariosService from '@/services/GestionUsuariosService';
import toast from "@/mixins/ToastMixin.js";
import HistorialImportaciones from '@/components/Usuarios/HistorialImportaciones.vue';
import ModalImportarUsuarios from '@/components/Usuarios/ModalImportarUsuarios.vue';
import ModalEditarUsuario from '@/components/Usuarios/ModalEditarUsuario.vue';

export default {
  computed: {
    rolesFilterOptions() {
      return [
        { value: '', text: 'Todos los roles' },
        ...this.item_roles.map(r => ({ value: r.id, text: r.name || r.text || r.label }))
      ];
    },
    isAdmin() {
      const usuario = this.$store.getters.usuario;
      return usuario && usuario.roles && usuario.roles.some(r => r.name === 'admin');
    },
    isGestorEscolarEstudiante() {
      const usuario = this.$store.getters.usuario;
      return usuario && usuario.roles && usuario.roles.some(r => r.name === 'gestorEscolarEstudiante');
    }
  },
  mixins: [toast],
  components: { 
    HistorialImportaciones,
    ModalImportarUsuarios,
    ModalEditarUsuario
  },
  data() {
    return {
      showResumenModal: false,
      resumenAvances: null,
      showImportarModal: false,
      showHistorialModal: false,
      showEditarModal: false,
      usuarioSeleccionado: null,
      users: [],
      usuariosOriginales: [],
      ModalEliminar: false,
      userEliminar: {},
      fields: [
        { key: 'id', label: 'Id' },
        { key: 'name', label: 'Nombre' },
        { key: 'email', label: 'Email' },
        { key: 'escuela', label: 'Escuela' },
        { key: 'grupos', label: 'Grupos' },
        { key: 'roles', label: 'Rol(es)' },
        { key: 'fecha_creacion', label: 'Fecha de creación' },
        { key: 'ultima_sesion', label: 'Última fecha de inicio de sesión' },
        { key: 'estatus', label: 'Estatus' },
        { key: 'actions', label: 'Opciones', sortable: false }
      ],
      currentPage: 1,
      perPage: 10,
      total: 0,
      search: '',
      selectedRol: '',
      selectedEstatus: '',
      item_roles: [],
      estatusFilterOptions: [
        { value: '', text: 'Todos' },
        { value: 1, text: 'Activo' },
        { value: 0, text: 'Inactivo' }
      ],
      item_escuelas: [],
      gruposAprende_items: [],
      licenciasInfo: {
        licencias_activas: null,
        licencias_disponibles: null,
        licencias_total: null,
        porcentaje_uso: null,
        escuela_nombre: null
      }
    }
  },
  mounted() {
    this.getEscuelas();
    this.getRoles();
    this.getGruposAprende();
    this.cargarUsuarios();
  },
  methods: {
    abrirModalHistorial() {
      this.showHistorialModal = true;
    },
    async abrirModalCurriculas(user) {
      try {
        this.showResumenModal = true;
        this.resumenAvances = null;
        const response = await this.$api.get(`/api/usuarios/resumen-avances/${user.id}`);
        this.resumenAvances = response.data.resumen || {};
      } catch (error) {
        this.resumenAvances = {};
        this.toast('b-toaster-bottom-center', true, 'No se pudo cargar el resumen de avances', 'danger');
      }
    },
    abrirModalImportar() {
      this.showImportarModal = true;
    },
    onImportacionExitosa() {
      this.cargarUsuarios();
    },
    editUser(user) {
      // Buscar el usuario original completo por ID
      const usuarioOriginal = this.usuariosOriginales.find(u => u.id === user.id);
      this.usuarioSeleccionado = usuarioOriginal || user;
      this.showEditarModal = true;
    },
    nuevoUser() {
      this.usuarioSeleccionado = null;
      this.showEditarModal = true;
    },
    onUsuarioGuardado() {
      this.cargarUsuarios();
    },
    onModalCerrado() {
      this.usuarioSeleccionado = null;
    },
    async getGruposAprende() {
      const response = await this.$api.get("/api/users/GruposUsuario");
      let { gruposUsuarios } = response.data;
      this.gruposAprende_items = gruposUsuarios;
    },
    async getEscuelas() {
      try {
        const response = await this.$api.get("/api/gestion-u/escuelas");
        this.item_escuelas = response.data.resultSet;
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    async getRoles() {
      try {
        const response = await this.$api.get("/api/gestion-u/roles");
        this.item_roles = response.data.resultSet;
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    async cargarUsuarios() {
      try {
        const params = {
          page: this.currentPage,
          per_page: this.perPage,
          search: this.search,
          rol: this.selectedRol !== '' ? Number(this.selectedRol) : '',
          estatus: this.selectedEstatus
        };
        
        // Si el usuario es gestorEscolarEstudiante, filtrar solo usuarios de su dominio
        const usuarioLogueado = this.$store.getters.usuario;
        const esGestorEscolar = usuarioLogueado && usuarioLogueado.roles && 
                                usuarioLogueado.roles.some(r => r.name === 'gestorEscolarEstudiante');
        
        if (esGestorEscolar && usuarioLogueado.email) {
          const emailParts = usuarioLogueado.email.split('@');
          if (emailParts.length === 2) {
            params.dominio = emailParts[1];
          }
        }
        
        const response = await this.$api.get('/api/usuarios', { params });
        
        const usuarios = response.data.data || [];
        
        // Guardar los datos originales completos
        this.usuariosOriginales = usuarios;
        
        // Mapear para mostrar en la tabla
        this.users = usuarios.map(u => ({
          id: u.id || 0,
          name: u.name || u.nombre || '',
          email: u.email || '',
          correo_alternativo: u.correo_alternativo || u['correo_alternativo'] || u['Correo alternativo'] || '',
          escuela: u.escuela || '',
          grupos: u.grupos ? u.grupos.join(', ') : '',
          roles: u.roles ? u.roles.join(', ') : '',
          fecha_creacion: u.fecha_creacion || '',
          ultima_sesion: u.ultima_sesion || '',
          estatus: u.estatus || '',
          puede_eliminar: u.puede_eliminar !== undefined ? u.puede_eliminar : true,
          tiene_avance: u.tiene_avance || false
        }));
        this.total = response.data.total;
        this.perPage = response.data.per_page;
        this.currentPage = response.data.current_page;
        
        // Capturar información de licencias
        if (response.data.licencias_info) {
          this.licenciasInfo = {
            licencias_activas: response.data.licencias_info.licencias_activas || 0,
            licencias_disponibles: response.data.licencias_info.licencias_disponibles || 0,
            licencias_total: response.data.licencias_info.licencias_total || 0,
            porcentaje_uso: response.data.licencias_info.porcentaje_uso || 0,
            escuela_nombre: response.data.licencias_info.escuela_nombre || ''
          };
        }
      } catch (e) {
        this.users = [];
        this.total = 0;
        this.$bvToast && this.$bvToast.toast('No se pudo cargar la lista de usuarios', { variant: 'danger' });
      }
    },
    buscarUsuarios() {
      this.currentPage = 1;
      this.cargarUsuarios();
    },
    filtrarUsuarios() {
      this.currentPage = 1;
      this.cargarUsuarios();
    },

    showModalEliminar(user) {
      this.userEliminar = user;
      this.ModalEliminar = true;
    },
    hideModalEliminar() {
      this.ModalEliminar = false;
      this.userEliminar = {};
    },
    async deleteUser() {
      try {
        const response = await GestionUsuariosService.delete(this.userEliminar.id);
        let { success, message, color } = response.data;
        if (success) {
          this.ModalEliminar = false;
          this.userEliminar = {};
          this.cargarUsuarios();
        }
        this.toast('b-toaster-bottom-center', true, message, color);
      } catch (error) {
        this.toast('b-toaster-bottom-center', true, 'Ocurrió un error, favor de comunicarse con su administrador 🙏', "danger");
      }
    },
    async exportarUsuarios() {
      try {
        const params = {
          search: this.search,
          rol: this.selectedRol,
          estatus: this.selectedEstatus,
        };
        
        // Si el usuario es gestorEscolarEstudiante, agregar filtro de dominio
        const usuarioLogueado = this.$store.getters.usuario;
        const esGestorEscolar = usuarioLogueado && usuarioLogueado.roles && 
                                usuarioLogueado.roles.some(r => r.name === 'gestorEscolarEstudiante');
        
        if (esGestorEscolar && usuarioLogueado.email) {
          const emailParts = usuarioLogueado.email.split('@');
          if (emailParts.length === 2) {
            params.dominio = emailParts[1];
          }
        }
        
        const response = await this.$api.get('/api/usuarios/export', {
          params,
          responseType: 'blob',
          headers: { 'Accept': 'text/csv' },
        });
        if (!response.data || response.data.size === 0) throw new Error('Sin archivos');
        const blob = new Blob([response.data], { type: 'text/csv' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        // Obtener el nombre del archivo del header Content-Disposition
        let filename = 'usuarios.csv';
        let disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']);
        // Axios a veces no expone los headers correctamente con blobs, intentar obtenerlo del request si es posible
        if (!disposition && response.request && response.request.getResponseHeader) {
          disposition = response.request.getResponseHeader('content-disposition');
        }
        if (disposition && disposition.indexOf('filename=') !== -1) {
          filename = disposition.split('filename=')[1].replace(/['";]/g, '').trim();
        }
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (e) {
        this.toast('b-toaster-bottom-center', true, e.message || 'No se pudo exportar la lista', 'danger');
      }
    }
  }
}
</script>

<style scoped>
  .badge {
    text-transform: none;
    font-size: 14px;
  }
  
  .tab-content {
    max-height: 500px;
    overflow-y: auto;
  }
  
  .b-table {
    font-size: 13px;
  }
  
  .b-progress {
    height: 25px;
    font-size: 12px;
  }
</style>